import { render, staticRenderFns } from "./ResumeBar.vue?vue&type=template&id=bc5826e6&"
import script from "./ResumeBar.vue?vue&type=script&lang=js&"
export * from "./ResumeBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports